query billingOnboardingDetails($companyId: ID!) {
  billingOnboardingDetails(companyId: $companyId) {
    paymentProviderRole
    isSignupComplete
  }
}
